import { render } from "./InspectionTemplate.vue?vue&type=template&id=371eb906&ts=true"
import script from "./InspectionTemplate.vue?vue&type=script&lang=ts"
export * from "./InspectionTemplate.vue?vue&type=script&lang=ts"

import "./InspectionTemplate.vue?vue&type=style&index=0&id=371eb906&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__